import { useLayoutEffect, useRef } from "react";
import { gsap } from "../utils/gsap";
import { assetUrl } from "../utils/paths";

const ParallaxBackground = () => {
  const rootRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    const prefersReduced =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;

    const ctx = gsap.context(() => {
      const scrollConfig = {
        trigger: root,
        start: "top top",
        end: "bottom top",
        scrub: true,
      };

      const layers: { selector: string; y?: number; x?: number }[] = [
        { selector: ".parallax-layer--mountain3", y: 70 },
        { selector: ".parallax-layer--planets", x: -20 },
        { selector: ".parallax-layer--mountain2", y: 30 },
      ];

      layers.forEach(({ selector, x, y }) => {
        const el = root.querySelector(selector);
        if (!el) return;
        const target = x ? { xPercent: x } : { yPercent: y };
        gsap.to(el, {
          ...target,
          ease: "none",
          scrollTrigger: scrollConfig,
        });
      });
    }, root);

    return () => ctx.revert();
  }, []);

  return (
    <section className="absolute inset-0 bg-black/40" ref={rootRef}>
      <div className="relative h-screen overflow-y-hidden w-full">
        {/* Sky - High Priority LCP Candidate */}
        <div className="absolute inset-0 w-full h-full -z-50 parallax-layer--sky">
          <picture>
            <source srcSet={assetUrl("optimized/sky.avif")} type="image/avif" />
            <img
              src={assetUrl("optimized/sky.webp")}
              alt=""
              width="1920"
              height="1080"
              className="w-full h-full object-cover"
              // @ts-ignore
              fetchPriority="high"
            />
          </picture>
        </div>

        {/* Mountain 3 */}
        {/* <div className="absolute inset-0 w-full h-full -z-40 parallax-layer--mountain3">
          <picture>
            <source
              srcSet={assetUrl("optimized/mountain-3.avif")}
              type="image/avif"
            />
            <img
              src={assetUrl("optimized/mountain-3-1280.webp")}
              alt=""
              width="1920"
              height="1080"
              className="w-full h-full object-cover"
            />
          </picture>
        </div> */}

        {/* Planets */}
        <div className="absolute inset-0 w-full h-full -z-30 parallax-layer--planets">
          <picture>
            <source
              srcSet={assetUrl("optimized/planets.avif")}
              type="image/avif"
            />
            <img
              src={assetUrl("optimized/planets-1280.webp")}
              alt=""
              width="1920"
              height="1080"
              className="w-full h-full object-cover"
            />
          </picture>
        </div>

        {/* Mountain 2 */}
        <div className="absolute inset-0 w-full h-full -z-20 parallax-layer--mountain2">
          <picture>
            <source
              srcSet={assetUrl("optimized/mountain-2.avif")}
              type="image/avif"
            />
            <img
              src={assetUrl("optimized/mountain-2-1280.webp")}
              alt=""
              width="1920"
              height="1080"
              className="w-full h-full object-cover"
            />
          </picture>
        </div>

        {/* Mountain 1 - Foreground */}
        <div className="absolute inset-0 w-full h-full -z-10 parallax-layer--mountain1">
          <picture>
            <source
              srcSet={assetUrl("optimized/mountain-1.avif")}
              type="image/avif"
            />
            <img
              src={assetUrl("optimized/mountain-1-1280.webp")}
              alt=""
              width="1920"
              height="1080"
              className="w-full h-full object-cover"
            />
          </picture>
        </div>

        <div
          className="absolute inset-0 -z-5 parallax-layer__gradient"
          style={{
            background:
              "radial-gradient(900px 520px at 12% 12%, #4a86ff24, transparent 60%), radial-gradient(700px 600px at 85% 14%, var(--pricing-accent-shadow), transparent 70%), radial-gradient(820px 520px at 18% 78%, #4a86ff1f, transparent 65%), radial-gradient(650px 520px at 80% 92%, var(--pricing-accent-shadow), transparent 70%)",
          }}
        />
      </div>
    </section>
  );
};

export default ParallaxBackground;
